import { BlogType } from 'Redux/Types/BlogsTypes'

const ArraysBlog: BlogType = {
  id: '1',
  tag: 'JavaScript',
  title: 'The 8 Must Know JavaScript Array Methods',
  date: '04.2.2021',
  timeToRead: 2,
  paragraphs: [
    {
      title: 'Filter',
      text: [
        'Iterates over each item and returns only those items for which the callback function test have passed (returned true)',
        'All the items that are less than $100 in price are going to be in our new filtered items array.',
        'This `filter` method is super easy to use, all you do is return a boolean for each value and if its true it is in the new array.',
        'Note: This method, and all the other methods do not change the underlying object you are filtering over.',
      ],
      code: `const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const filteredItems = items.filter((item) => item.price <= 100 )
      // Result: [{ name: "Bike", price: 100 }, { name: "Album", price: 10 }, { name: "Book", price: 5 }, { name: "Keyboard", price: 25 },]
      `,
    },
    {
      title: 'Map',
      text: [
        'Allows you to take one array and convert it into another array, so all the items in the array will look slightly different',
        'Iterates over each item and returns for each item whatever what returned specified in the return callback function.',
        'We get a new array that is just full of all the different prices',
        'This is super convenient when you want to take an object for example and just get the names.',
        'It has billion of different uses and you will find yourself using this all the time over for exmaple a normal for loop.',
      ],
      code: `const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const mappedItems = items.map((item) => item.price)
      // Result: [100, 200, 10, 5, 500, 1000, 25]
      `,
    },
    {
      title: 'Find',
      text: [
        'Allows you to find a single object in an array.',
        'It takes the exact same single callback function with item as the parameter.',
        'All we do is we have a boolean statement, which is going to return the item for the first true one found.',
      ],
      code: `const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const foundItems = items.find((item) => item.name === "Book")
      // Result: { name: "Book", price: 5 }
      `,
    },
    {
      title: 'ForEach',
      text: [
        'Iterates over each item in the array, like a for loop. Unlike these other methods, it doesn’t return anything.',
        'This will work very similar to a for loop, but it is going to take a callback function instead.',
        'For every single item it is going to execute the block of code inside the callback function.',
      ],
      code: `const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      items.forEach((item) => console.log(item))
      // Result: prints out every object of the array
      // Example: 1: { name: "Bike", price: 100 }
      // 2: { name: "TV", price: 200 } ...
      `,
    },
    {
      title: 'Some',
      text: [
        'Instead of returning a brand new array, it is going to return a boolean',
        'We can check if some of the items in this array have a price less than $100',
        'It will check our return value. As soon as a single value returns true, it is going to return true',
      ],
      code: `const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const hasInexpensiveItems = items.some((item) => item.price <= 100)
      // Result: true
      `,
    },
    {
      title: 'Every',
      text: [
        'Checks to make sure every single item in the array fall under the condition',
      ],
      code: `
        const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const allItemsAreInexpensive = items.every((item) => item.price <= 100)
      // Result: false
      `,
    },
    {
      title: 'Reduce',
      text: [
        'It does some operation on the arrray and returns a combination of all those different operations',
        'We can use reduce method to calculate the sum of prices',
        'It takes two arguments, a callback function with two arguments being the currentTotal (accumulator) and the second argument each item in the array and second argument is the starting value of the accumulator',
        '1st parameter is a callback and second one is the initial value. We iterate over each item and usually add one of the fields of our item object (eg: price) to the accumulator. - Therefore eventually returning a new value with the sum of the price. This will iterate until it reaches the last value of our array, adding each item field to the accumulator and then returning us the accumulator. - This is incredibly useful when you need to calculate some cumulative sum between the values of an array.',
      ],
      code: `
      const items = [
        { name: "Bike", price: 100 },
        { name: "TV", price: 200 },
        { name: "Album", price: 10 },
        { name: "Book", price: 5 },
        { name: "Phone", price: 500 },
        { name: "Computer", price: 1000 },
        { name: "Keyboard", price: 25 },
      ]

      const allItemsAreInexpensive = items.reduce((currentTotal, item) => item.price + currentTotal, 0)
      // Result: 1840
      `,
    },
  ],
}

const RustAndWebAssembly: BlogType = {
  id: '2',
  tag: 'Rust',
  title: 'Rust and WebAssembly',
  date: '04.8.2021',
  timeToRead: 16,
  paragraphs: [
    {
      title: 'Why wasm?',
      text: [
        'Write application for the web in languages other than JavaScript. Imagine a world where you can write application in C++ / Rust / Python / Go and deliver that software to the end user in a web browser (without any installation and native performance).  This world became a reality in December 2019, when WebAssembly became an official W3C (World Wide Web Consortium) standard.',
        'It includes a low level language, similar to assembly, which can be represented as text and then converted into a binary format that runs in all modern browsers.',
        'However, you won’t actually write this code, but rather use it as your compilation target, for programs written in other languages.',
        'This generated byte-code  can be compiled but the browser and run at native speed. The reason this is so significant, prior to Web Assembly, the only thing that could ever run in a browser was JavaScript. That means that anything you want to run in the browser either had to be written by JavaScript or by something that transpiles into JavaScript (such as TypeScript, CoffeeScript and others). Therefore, some application require greater performance and speed than JavaScript can possibly offer due its its dynamically type nature and garbage collector memory management, we had to find a way to offload computationally expensive tasks for more performant languages.',
      ],
      spacing: true,
    },
    {
      title: 'Existing applications of similar technologies',
      text: [
        'For example, you might build a game in unit in C# and compile in to Web Assembly, where it can be delivered in browsers. However, it is important to note that it is not intended to replace JavaScript, but rather they are meant to be used side by side.',
        'Figma, for example, uses React JS for its outer UI.',
        'But on the inside, you have a high performant C++ design tool that feels just as fast as native software.',
      ],
      spacing: true,
    },
    {
      title: 'Small .wasm sizes',
      text: [
        `Because the.wasm must be downloaded over the network, code size is critical. Rust doesn't have a runtime, so.wasm files are short since there's no added bloat like a garbage collector.`,
        `You only pay for the functions you actually use (in terms of code size).`,
      ],
      spacing: true,
    },
    {
      title: 'Plays well with others',
      text: [
        `Rust and WebAssembly are compatible with JavaScript tools. It supports ECMAScript modules, meaning you can keep using your favorite tools like npm and Webpack.`,
      ],
      spacing: true,
    },
    {
      title: 'Further research',
      text: [`https://rustwasm.github.io/docs/book/introduction.html`],
      spacing: true,
    },
  ],
}

const JavaScriptCompilationEngines: BlogType = {
  id: '3',
  tag: 'JavaScript',
  title: 'Overview of JavaScript Engines',
  date: '04.12.2021',
  timeToRead: 10,
  paragraphs: [
    {
      title: 'Methods for JavaScript compilation',
      text: [
        `Despite the fact that JavaScript is dynamically typed, which makes it hard for the compiler to optimize our code, how does it achieve high speed and performance? The trick that all JavaScript engines use so called, Just In Time (JIT) compilation.`,
        `Meaning that we are generating the machine code during runtime, not Ahead Of Time (AOT).`,
        `In other words, we are not first compiling the code, finish the compilation and run the code, instead we a mixing these steps together, which therefore allows us to use the information from running the code to recompile the code. `,
        `So, we are compiling the source code just in time as we need it. We collect some information while we run it and then we recompile this source code.`,
      ],
      spacing: true,
    },
    {
      title: 'Comparison to other languages',
      text: [
        `If we think about C++, which is compiled ahead of time. Which are two separate steps, we first compile it, then we get an executable and you run this executable. Whereas in JavaScript this is one step.`,
      ],
    },
    {
      title: 'Examples of JS processes',
      text: [
        `If you start a Node process, you say «node run», you don’t say «node compile» and then run it, instead it is happening together.`,
        `Compilation and execution goes at the same time and there is feedback going back and forth with the aim to speed up the execution.`,
      ],
      spacing: true,
    },
    {
      title: 'JavaScript Engines',
      text: [
        `For side note, I want to make it clear, that despite all the optimization of the engines such as V8, JavaScript Web applications still struggle to attain and retain reliable performance.`,
        `As previously stated, JavaScript’s dynamic type system and garbage collection pauses don’t help and seemingly small code changes can result in drastic performance regressions if you accidentally wander of the JIT’s happy path`,
        `This is where WebAssembly with Rust / C++ comes in, which guarantees programmers low-level control and reliable performance in the browser.`,
        `It is free from the non-deterministic garbage collection pauses that plague JavaScript.`,
        `Programmers have control over indirection, monomorphization, and memory layout. I have a separate article talking about WebAssembly in more detail, linked <https://myportfolio-dev.web.app/blog/2>. `,
      ],
      spacing: true,
    },
    {
      title: 'WebAssembly',
      text: [
        `To give you more insight, web assembly have a huge amount of benefits when building web applications.`,
        `Furthermore, you don’t have to rewrite everything. Existing code bases don't need to be thrown away. You can start by porting your most performance-sensitive `,
        `JavaScript functions to Rust to gain immediate benefits. And you can even stop there if you want to. Rust and WebAssembly integrates with existing JavaScript tooling.`,
        `It supports ECMAScript modules and you can continue using the tooling you already love, like npm and Webpack.`,
      ],
      spacing: true,
    },
  ],
}

const RustVersusCPP: BlogType = {
  id: '4',
  tag: 'Educational',
  title: 'Rust vs C++',
  date: '05.24.2021',
  timeToRead: 18,
  paragraphs: [
    {
      text: [
        'This question comes up a lot lately, especially when considering whether learning rus is worth it or not and so I thought it could be a wonderful opportunity to make a new blog post discussing the differences between the two as well as what they share in common.',
      ],
    },
    {
      title: 'Similarities',
      text: [
        'Both C++ and Rust are system programming languages, which means they can be used to write low level code. Examples: Operating system kernels, firmware for microcontrollers but compared with C they offer a lot of abstraction that make it possible to go high level as well. For example writing games and web applications.',
      ],
      spacing: true,
    },
    {
      title: 'Memory and Thread safety',
      text: [
        'Neither of them use garbage collector to manage memory whcih make sthe code much more predictable, efficient and in many cases faster. Of course if you ever used C you will know that manging memory yourself is hard. Besides the cognitive overhead you are also running the risk of causing segmentation faults and undefined behaviors.',
        'For this reason, modern C++ introduced the concepts like smart pointers as a way to mitigate those memory related bugs. But depiste the significant improvments thwy are limited in the number of guarantees they can offer.',
        'Rust, however, takes a step further and introduces the concept of borrow checker. It is a component bundeled within the compiler itself that makes sure that a reference does not outlive the data it refers to, which out of the box prevents entire classes of memory and safety bugs.',
        'Another big selling points of Rust is its rich type system, which makes it possible to prevent data races at compile time. It does so by introducing two special traits `Sync` and `Send` which are used by the compiler to determine whether a multi-threaded operation is safe or not.',
        'While sharing some memory between threads is possible in Rust, the compiler will stop you from building a program that does so unsafely and hence preventing data races even before the program starts.',
        'Example (code below): If you want to mutate a variable from multiple threads the compiler will require you to wrap it with a mutex or something equivalent because in general mutating an asynchronized variable from multiple threads is unsafe. Unless a synchronization primitive or atomic operations are used.',
      ],
      code: `
        fn main() {
          let x = std::sync::Arc::new(std::sync::Mutex::new(1));

          let x_clone = x.clone();
          let handle = std::thread::spawn(move || {
            let mut reference = x_clone.lock().unwrap();
            *reference = 2;
          })

          {
            let mut reference = x.lock().unwrap();
            *reference = 3;
            println!("{}", *reference);
          }

          handle.join().unwrap();
        }
      `,
      spacing: true,
      lang: 'rust',
    },
    {
      title: 'Unsafe Rust',
      text: [
        'Up to this point we discussed the features of the so called safe rust which provides guarantees, like: memory safety and prevents undefined behavior, but there is also another version of the language known as `Unsafe Rust`.',
        'It basically gives you superpowers at the price of losing all those safety guarantees. There are two reasons why this is needed: Firstly, if you want to interact with the low level aspects of the operating system or hardware, those operation operations are inherently unsafe.',
        'If you want to execute them, you will have to explicitly tell the compiler who tries to protect you, to give up those safety guarantees.',
        'The second reason is the cases when we simply want to bypass the safety checks of the compiler when absolutely certain that an operation is correct.',
        'Rust programmers usually avoid the unsafe side as much as possible.',
      ],
      spacing: true,
    },
    {
      title: 'Package manager',
      text: [
        'This is an area in which rust is arguably better than C++. If you ever worked with Python or JavaScript, you will feel right at home with Cargo, the official package manager for rust.',

        'Installing a package is just a mtter of adding a line into the dependecy files, whereas in C++ udsing an external library can be a huge pain, especially if targeting multiple operating systems.',
        'Even though there are some attempts to bring modern package management to C++ such as Conan and VC Package, but they are far from being a standardazed or easy to use as Cargo.',
      ],
      spacing: true,
    },
    {
      title: 'Ecosystem',
      text: [
        'C++ ecosystem is huge, much bigger than the rust counterpart, as former has been around for multiple decades. As a result, there are many more libraries for C++ and thus there might be cases in which a suitable library is not available for a specific task when working with Rust',
        'The good news is that rust has very good foreign function interface, which means you can interface with C code very easoly from rust and thus also interface with C++ libraries by exposing a C API from them.',
        'Unfortunately, this is not always possible, especially in complex cases. There are some ongoing attempts to make it easier to create bindings between the two. An example is the CXX library (safe interop between Rust and C++), which is being developed by the Google Chrome team to investigate whether parts of the browser could be develloped in Rust in the future.',
      ],
      spacing: true,
    },
    {
      title: 'Macro System',
      text: [
        'Another interesting difference between the two languages is the macro system, which in Rust is much more powerful and safer. On the other hand, procedural macros are completely different, much more powerful and also complex.',
        'First of all, Rust ships with two kinds of macros: declarative and procedural. The former type is similar to the traditional C/C++ macros, with the difference that macros are hygenic, meaning that they cannot interfere with variables outside their scope and therefore don’t cause any unwanted side effects.',
        'They can be basically thought of as compiler plugins that receive the program syntax tree as input, manipulate it, and then return the enriched syntax tree as output. This makes it possible to create annotations, similarly to Java, that enrich the code at compile time',
      ],
      spacing: true,
    },
    {
      title: 'Conclusion (Key takeaways)',
      text: [
        'Rust is likely to be the future of system programming and the proff is that many big companies such as Microsoft and Apple are moving in that direction, by gradually integrating Rust with their product.',
        'But do not get me wrong, C++ is far from being dead and it is not going away anytime soon due to the increadibly vast amount of legacy code built with it but an increasing number of companies are choosing Rust over C++ for new products.',
      ],
      spacing: true,
    },
  ],
}

const ReadingTechnicalLiterature: BlogType = {
  id: '5',
  tag: 'Life-hacks',
  title: 'How do I read technical literature?',
  date: '06.24.2021',
  timeToRead: 18,
  paragraphs: [
    {
      text: [
        `In general, I'm going to tell you now what I am doing in order to fully perceive information from technical literature. The things that I will talk about are actually obvious, but I'm going to make sure that you accept the essence of these obvious things and, most importantly, have a clear algorithm of actions at hand.`,
        `By the way, this method is also suitable for recording lectures. And you know, for me it was always strange that students rewrite every word of the lecturer, and that lecturers give information simply by dumping the word text into their ears. And all of this gives the impression that one monkey dictates and the other writes down, do not be a monkey, do everything as efficiently as possible.`,
      ],
      spacing: true,
    },
    {
      title: 'Method stages:',
      text: [
        `- 1) Decomposition - we divide and conquer. For those who are not in the know, decomposition is the division of a large task into smaller ones. In general, this stage is needed to identify the smallest and most fundamental object of study. Or, more simply, it consists in the fact that when you come across a new term for yourself in a book, the essence of which the author is going to reveal, just write it out somewhere. For example, in a separate textbook or notebook. Simple, isn't it. Therefore, if we want to fully understand the book, we must understand as much as possible each individual term described in it.`,
      ],
      code: `Array is a language mechanic that provides many objects of the same type
      Syntax: Arr[] name = new type[dimension];
      `,
    },
    {
      text: [
        `- 2) Reason - Nothing in programming is done so easily, perhaps except for static inheritance in PHP. Of course, there are unnecessary things, but once they were necessary, they just were replaced by something new, and this unnecessary remains only so that the old code does not break. In general, your task is to write why the phenomenon or process that this term provides is needed. Thesis, as short as possible, and as simple as possible. No need to rewrite the words of the author, write as you understand yourself! If you cannot answer the question why or you are not sure of your wording, refer to other sources (google). Since very cool people are often not always very cool writers, and therefore you should not rely only on their wording, they are not always the best.`,
      ],
      code: `Array is a language mechanic that provides many objects of the same type
      Syntax: Arr[] name = new type[dimension];
      Why you need it:
      - Convenient for storing any number of objects of the same type.
      - Allows you to easily manipulate the objects it contains
      `,
    },
    {
      text: [
        `- 3) Concretization - in programming, practice is more important than theory. Nobody cares what you know there, everyone cares only about the result that you can give. This stage is needed to clearly understand where the new knowledge is applicable. Therefore, at this step, it is important to simulate specific situations in which it would be appropriate to use new knowledge. Just think of 2-3 different situations and program them.`,
      ],
      code: `Array is a language mechanic that provides many objects of the same type
      Syntax: Arr[] name = new type[dimension];
      Why you need it:
      - Convenient for storing any number of objects of the same type.
      - Allows you to easily manipulate the objects it contains

      Specific example (C# language):

      there is an array with the names of classmates
      string[] classmatesNames = new string[] {
        "Artem Moshnin",
        "Alexander Petrov",
        "Valera Ivanov",
        "Sasha Sidorov",
      }

      Array manipulation
      for (int i = 0; i < classmatesNames.length; i++) {
        classmatesNames[i] + " are amazing";
      }

      Displaying items to the console
      for (int i = 0; i < classmatesNames.length; i++) {
        Console.WriteLine(classmatesNames[i])
      }
      `,
    },
    {
      text: [
        `- 4) Structuring - It consists in combining similar elements and finding out what is the difference between them. Similar elemental as correctly have almost the same statements in the why graph and specific examples examples can be and can be completely interchangeable. Remember what I said in programming languages ​​nothing is done just like that? And this is the same case, someone made tools that are extremely similar, and this most likely makes sense. Therefore, we write down what the difference is and support with more specific examples that would reflect this difference most fully. This step is most notable because you will probably have to climb other sources to complete it, so feel free to do it.`,
      ],
    },
    {
      text: [
        `- 5) Building Hierarchies - programs are made up of large components, and large components are made up of smaller objects. And they, in turn, boil down to performing some actions with the most trivial data. For example, with a set of bytes or with an array of numbers. Something complex always consists of many things that are simple enough to understand. If the first step was to understand the role of each individual brick, each individual wall and the whole house as a whole. Then this stage is needed in order to realize how the connections are built between small parts and more complex ones. This is how you build connections with your friends. This will help you understand how more complex systems work.`,
      ],
    },
    {
      text: [
        `- Note: But there is one important point that applies primarily to beginners from my personal past experience, do not worry. For example, in some programming language, the simplest mechanism is "variables". Although in essence this is a rather complex thing, in fact it is a whole huge mechanism for managing the memory of your computer. But for this they look quite simple, because the creator of the programming language simply provided us with an easy interface for interacting with a computer. The creators of the operating system provided them with an easy interface for interacting with the system. Which, in turn, was provided with an easy interaction interface by the creators of the piece of iron, who, in turn, provided the physics of God. Therefore, you do not need to sweat and reserve a free memory cell, you do not need to worry about converting a number from the decimal number system to binary in order to place it in this bitwise location. You don't have to worry about accessing this variable.`,
      ],
    },
    {
      text: [
        `- To summarize, I believe that the key to understanding programming books is the correct structuring of information. Yes, my approach is quite complex and it takes additional time. For that, it will help you to more easily perceive information due to the fact that we first find the main thing by omitting any garbage and then, due to the fourth and fifth stages, the complete picture and complement it if there are not enough puzzles.`,
      ],
    },
    {
      title: 'Definitions',
      text: [
        `Encapsulation is a way to achieve "information hiding", so you don't need to "know the inner workings of a mobile phone to work with it." You have an interface to use device behavior without knowing the implementation details.`,
        `Abstraction, on the other hand, can be explained as the ability to use the same interface for different objects. Different implementations of the same interface may exist. The details are hidden by the encapsulation.`,
      ],
      spacing: true,
    },
  ],
}

const FlappyBirdAIGameLearning: BlogType = {
  id: '6',
  tag: 'Machine Learning',
  title: 'AI learns to Play Flappy Bird with Neural Networks',
  date: '08.15.2021',
  timeToRead: 16,
  paragraphs: [
    {
      title: 'References',
      text: [
        `GitHub repository for the project: https://github.com/Artem711/ML-NN-FlappyBirdGameplay`,
        `Inspiration was taken from CodeBullet: https://thebigcb.com/projects/FlappyBird`,
      ],
    },
    {
      title: 'Introduction to the project',
      text: [
        `In this project the AI teaches itself how to play Flappy Bird.
The way this works is that it starts completely random, having no idea what to do and how the game even operates.
Only after many generations of slowly learning and getting better, it finally picks up on patterns on what it can do to progress further in the level.`,
      ],
    },
    {
      title: 'Algorithms used to achieve the functionality',
      text: [
        `To achieve this, Genetic Algorithms and Neural Networks are being used together.
Genetic Algorithm is a part of Evolutionary Algorithms, specifically to generate high-quality solutions to optimization and search problems by relying on biologically inspired operators such as mutation, crossover, and selection.
`,
        `Evolutionary algorithms: https://www.mygreatlearning.com/blog/introduction-to-genetic-algorithm`,
        `Evaluation on combining NNs (Neural Networks) with GAs (Genetic Algorithms) to accelerate the learning process: https://towardsdatascience.com/gas-and-nns-6a41f1e8146d`,
        `The actual algorithm used is called NEAT = NeuroEvolution of Augmenting Topologies
After a few generations, the AI starts to get exponentially better. Until eventually it reaches the point where it cannot be beaten. It can beat the level infinetely and keep going without ever hitting a pipe. To me, this is increadibly fascinating!`,
      ],
      spacing: true,
    },
    {
      title: 'Input Layer of Neural Network',
      text: [
        'Neural networks consists of layer. First layer is the input layer. Input layer is what the network actually knows/sees. You can almost think of it as the eyes of the AI.',
        `In this scenario, the input arguments are going to the 1) Position of bird 2) Positon of the two pipes in front of the bird. Or even better, the distance between the bird and the two pipes individually`,
      ],
    },
    {
      title: 'Output Layer of Neural Network',
      text: [
        `Each neural network has one input and one output layer. This Output layer is going to tell our AI what to do, in our case we have to know whether we have to jump or not, hence we are going to use one neuron to make the decisions of jumping or not.`,
        `Each of the inputs will be multiplied by its corresponding weight,the results will be summed and bias will be added to get our weighted sum. The weights and the bias, is what the algorithm will be learning over time in order to improve its performance in the game`,
        `The obtained weighted sum will be the input to our Activation Function, which in this case will be 'TanH', whose range is ]-1, 1[ and domain of all real values`,
        `In our case, {if tanh(x) > 0.5: jump else: don't jump}`,
      ],
      spacing: true,
    },
    {
      title: 'Determening the weights and biases of our Neural Network',
      text: [
        `Weights and bias are going to be learned over time by the neural network.`,
        `The algorithm to determine them I used is NEAT. Other algorithms could of also been used, but for the game like Flappy Bird NEAT makes a lot of sense to use.`,
        `NEAT is specifically inspired of Natural Selection. Natural Selection is the process of generations continually learning and getting better and better until eventually they get as good as they can get, whcih is exactly what we are trying to achieve in this game`,
      ],
      spacing: true,
    },
    {
      title: 'How NEAT works with Neural Networks?',
      text: [
        `We start by creating a completely random population of birds. Each bird is going to consist of a bird and a neural network that controls that bird. The Neural Network is going to start with random weights and biases.`,
        `We are going to then test each of the Neural network on our game and evaluate their fitness. Fitness is different depending on the game. In Flappy Bird fitness is how far the bird have progressed through the level. In this case I chose to give another point to the bird for each frame it moves without dying = fitness score`,
        `At the end of the simulation when all of our birds died, we are going to see which ones perform the best in this set of population. We are going to take a certtain percentage of those best performed and breed them together. Now we will have offspring from the best birds from last generation and we hope these birds will perform better than the previous generation. `,
        `Note: This explanation is very much simplified from reality, so here is a link to a paper for your to understand technical details of NEAT (http://nn.cs.utexas.edu/downloads/papers/stanley.cec02.pdf)`,
      ],
      spacing: true,
    },
  ],
}

export const BlogsData: Array<BlogType> = [
  FlappyBirdAIGameLearning,
  ReadingTechnicalLiterature,
  // RustVersusCPP,
  JavaScriptCompilationEngines,
  RustAndWebAssembly,
  ArraysBlog,
]
